var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.items,"item-text":_vm.text,"item-value":_vm.value,"dense":"","outlined":"","filled":"","clearable":"","label":"Seleccione un establecimiento","no-data-text":"No hay establecimientos"},on:{"change":_vm.setPlace},model:{value:(_vm.place),callback:function ($$v) {_vm.place=$$v},expression:"place"}})
}
var staticRenderFns = []

export { render, staticRenderFns }